let timer = null

function debounce (f, delay, ...args) {
  if (timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    f(...args)
    timer = null
  }, delay)
}

export default debounce